import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Award } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-8 md:py-20 px-4 max-w-4xl mx-auto" data-id="element-201">
      <FadeIn data-id="element-202">
        <div className="bg-gradient-to-br from-green-950/40 via-gray-900 to-black border border-green-500/30 rounded-2xl md:rounded-[2.5rem] p-5 md:p-16 text-center relative overflow-hidden shadow-[0_0_50px_rgba(34,197,94,0.05)]" data-id="element-203">
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#22c55e_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-204"></div>

          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-transparent via-green-500 to-transparent" data-id="element-205"></div>

          <div className="relative z-10" data-id="element-206">
            <div className="inline-flex items-center justify-center w-20 h-20 md:w-28 md:h-28 rounded-full bg-green-500/10 mb-4 md:mb-8 border-2 border-green-500/20 relative" data-id="element-207">
              <div className="absolute inset-0 bg-green-500/20 blur-2xl rounded-full animate-pulse" data-id="element-208"></div>
              <ShieldCheck className="w-10 h-10 md:w-14 md:h-14 text-green-500 relative z-10" data-id="element-209" />
              <div className="absolute -bottom-2 -right-2 bg-green-500 text-black rounded-full p-1.5 md:p-2 shadow-lg" data-id="element-210">
                <Award className="w-4 h-4 md:w-5 md:h-5" data-id="element-211" />
              </div>
            </div>

            <h2 className="text-2xl md:text-5xl font-black mb-4 md:mb-8 text-white tracking-tight" data-id="element-212">
              GARANTÍA 7 DÍAS <br className="md:hidden" data-id="element-213" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-600" data-id="element-214">
                — SIN PREGUNTAS
              </span>
            </h2>

            <div className="space-y-3 md:space-y-6 text-base md:text-2xl text-gray-300 font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-215">
              <p data-id="element-216">Abrís los tomos. Los usás en tu consultorio.</p>
              <p data-id="element-217">Si en 7 días no es lo que esperabas:</p>
              <motion.div whileHover={{
              scale: 1.05
            }} className="bg-green-500/10 border border-green-500/30 rounded-2xl p-4 md:p-6 mt-4 md:mt-8 inline-block" data-id="element-218">
                <p className="text-green-400 font-black text-lg md:text-3xl" data-id="element-219">
                  → Devolución del 100%. <br className="md:hidden" data-id="element-220" />
                  Sin formularios. Sin drama.
                </p>
              </motion.div>
              <p className="text-xs md:text-sm text-gray-500 mt-5 md:mt-10 pt-4 md:pt-8 border-t border-gray-800/50 uppercase tracking-widest font-bold" data-id="element-221">
                Tasa de devoluciones: menos del 1%.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}